export class ResultDto {
   result: string
  
    static create() {
      return new ResultDto()
    }
  }